import { render } from "./MyLibrary.vue?vue&type=template&id=79c766d8&scoped=true"
import script from "./MyLibrary.vue?vue&type=script&lang=js"
export * from "./MyLibrary.vue?vue&type=script&lang=js"

import "./MyLibrary.vue?vue&type=style&index=0&id=79c766d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79c766d8"]])

export default __exports__